export default function pageLoadingJob({ setProgress, complete }) {
  const NAVIGATION_EVENT = "app:navigation-change";
  const INITIAL_PROGRESS = 15;
  const TRICKLE_STEP = 8;
  const TRICKLE_INTERVAL_MS = 120;
  const COMPLETE_DELAY_MS = 280;

  let currentProgress = 0;
  let trickleIntervalId = null;
  let completeTimeoutId = null;

  const clearTimers = () => {
    if (trickleIntervalId) {
      clearInterval(trickleIntervalId);
      trickleIntervalId = null;
    }

    if (completeTimeoutId) {
      clearTimeout(completeTimeoutId);
      completeTimeoutId = null;
    }
  };

  const startProgress = () => {
    clearTimers();

    currentProgress = INITIAL_PROGRESS;
    setProgress(currentProgress);

    trickleIntervalId = setInterval(() => {
      currentProgress = Math.min(currentProgress + TRICKLE_STEP, 90);
      setProgress(currentProgress);
    }, TRICKLE_INTERVAL_MS);
  };

  const finishProgress = () => {
    clearTimers();
    setProgress(100);
    complete();
  };

  const queueFinish = () => {
    clearTimers();
    completeTimeoutId = setTimeout(finishProgress, COMPLETE_DELAY_MS);
  };

  const runPageTransition = () => {
    startProgress();
    queueFinish();
  };

  const originalPushState = window.history.pushState;
  const originalReplaceState = window.history.replaceState;

  const emitNavigationChange = () => {
    window.dispatchEvent(new Event(NAVIGATION_EVENT));
  };

  window.history.pushState = function pushStateWithProgress(...args) {
    originalPushState.apply(this, args);
    emitNavigationChange();
  };

  window.history.replaceState = function replaceStateWithProgress(...args) {
    originalReplaceState.apply(this, args);
    emitNavigationChange();
  };

  const handleWindowLoad = () => {
    finishProgress();
  };

  window.addEventListener("load", handleWindowLoad, { once: true });
  window.addEventListener("popstate", runPageTransition);
  window.addEventListener("hashchange", runPageTransition);
  window.addEventListener(NAVIGATION_EVENT, runPageTransition);

  if (document.readyState === "complete") {
    runPageTransition();
  } else {
    startProgress();
  }

  return () => {
    clearTimers();
    window.history.pushState = originalPushState;
    window.history.replaceState = originalReplaceState;
    window.removeEventListener("load", handleWindowLoad);
    window.removeEventListener("popstate", runPageTransition);
    window.removeEventListener("hashchange", runPageTransition);
    window.removeEventListener(NAVIGATION_EVENT, runPageTransition);
  };
}